import React, { Component } from "react";
import { LocalStorageService, FollowupContractsService, CacheStorageService } from "../../../services";
import { CreateDocumentsPrincipalView } from "../../views"
import { NIL as NIL_UUID } from 'uuid';
import moment from "moment"
import { getNavigatorTimezone } from "../../../utils";

class CreateDocumentsPrincipalAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingView: false,
            contracts: [],
            questionnaires: [],
            companies: []
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService()
    followUpContractsService = new FollowupContractsService(this.url)
    cacheStorageService = new CacheStorageService();
    timezone = getNavigatorTimezone()

    token = ''
    user = {}

    async componentDidMount() {
        this.toggleLoadingView(true)
        let messageError = this.props.t("digitalContractHomeAction.error")
        let cacheSearch = await this.cacheStorageService.getCachedDataByUrl('/searchContract')
        let ENV = process.env
        let dataSearch = (cacheSearch) ? {
            companyId: cacheSearch.companyId,
            questionnaireId: cacheSearch.questionnaireId,
            startdate: cacheSearch.startdate,
            endDate: cacheSearch.endDate
        } : null

        try {
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            this.user = this.localStorageService.getLocalStorageItem("user")
            if (cacheSearch) {
                //If pass few mintes delete search
                let createdDate = new Date(cacheSearch.createdDate)
                let now = new Date()
                let momentLastCreated = moment(createdDate)
                let momentToday = moment(now)
                let differenceMinutes = momentToday.diff(momentLastCreated, 'minutes')
                if (differenceMinutes > Number(ENV.REACT_APP_SEARCH_CONTRACT_MINUTES_EXPIRATION)) {
                    await this.cacheStorageService.deleteUrlFromCache('/searchContract')
                }
            } else {
                this.getContracts()
            }
            this.getContractMonitoring()
            this.setState({
                dataSearch
            })
        } catch (error) {
            this.toggleLoadingView(false)
            this.props.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    getContracts = async () => {
        let messageError = 'Ocurrió un error al cosultar los contratos'
        let ENV = process.env
        let lawyerId = ''
        let userId = ''
        let userType = this.user.userMetaData.userRoles

        let startDate = moment().add(-60, 'days').format("DD-MM-YYYY")
        let endDate = moment().format("DD-MM-YYYY")

        try {
            userType.map((type) => {
                if ([ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER, ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH].includes(type.role.key)) {
                    this.setState({
                        disableLawyer: true
                    })
                    lawyerId = this.user.userMetaData.userMifirma.id
                }
                if (type.role.key === ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_APPLICANT) {
                    this.setState({
                        disableUser: true
                    })
                    userId = this.user.userMetaData.userMifirma.id
                }
            })

            let allContracts = await this.followUpContractsService.getContractFilter(this.token, lawyerId, userId, startDate, endDate, this.timezone)
            if (!allContracts || allContracts.length <= 0 || !allContracts[0].clientContract) throw new Error('Ocurrió un error al cosultar los contratos')

            let contracts = allContracts[0].clientContract.map((contract) => {
                contract.typeContract = contract.questionnaire.name
                return contract
            })

            contracts = contracts.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

            this.setState({
                contracts
            })
            this.toggleLoadingView(false)

        } catch (error) {
            this.toggleLoadingView(false)
            this.props.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }

    getContractMonitoring = async () => {
        let messageError = 'Ocurrió un error al cosultar los contratos'

        try {
            let contractsMonitoring = await this.followUpContractsService.getContractMonitoring(this.token)
            if (contractsMonitoring && Number(contractsMonitoring.statusCode) === 200) {
                let companies = contractsMonitoring.data[0].userRoleCompany.map((company) => {
                    let copmanyToShow = {
                        id: (company.company.id) ? company.company.id : '0',
                        companyName: (company.company.businessName) ? `${company.company.businessName}`.substring(0, 35) : '---'
                    }
                    return copmanyToShow
                });

                let questionnaires = contractsMonitoring.data[0].questionnaire.map((questionnaire) => {
                    questionnaire.name = `${questionnaire.name}`.substring(0, 35)
                    return questionnaire
                });

                companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
                questionnaires = questionnaires.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

                let questionaireAdd = [{
                    id: NIL_UUID,
                    name: this.props.t("digitalContractHomeView.main.allTypesContracts")
                }]

                let companiesAdd = [
                    {
                        id: '1',
                        companyName: this.props.t("digitalContractHomeView.main.allCompanies")
                    },
                    {
                        id: NIL_UUID,
                        companyName: this.props.t("digitalContractHomeView.main.notAssignedCompany")
                    }
                ]

                companies = companiesAdd.concat(companies)
                questionnaires = questionaireAdd.concat(questionnaires)

                this.setState({
                    companies,
                    questionnaires
                })

            } else {
                this.toggleLoadingView(false)
                this.props.toggleErrorRequesting(messageError, 4000, true, "/")
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.props.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }

    handleSearchContracts = async (companyId, questionnaireId, dateStart, dateEnd, setShowPoup) => {
        this.toggleLoadingView(true)
        let messageError = 'Ocurrió un error al cosultar los contratos'
        let ENV = process.env

        let paramDateStart = moment(dateStart).format('DD-MM-YYYY')
        let paramDateLimit = moment(dateEnd).format('DD-MM-YYYY')

        try {

            let userType = this.user.userMetaData.userRoles
            let lawyerId = ''
            let userId = ''

            userType.map((type) => {
                if ([ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER, ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_LAWYER_AUTH].includes(type.role.key)) {
                    lawyerId = this.user.userMetaData.userMifirma.id
                }
                if (type.role.key === ENV.REACT_APP_ROLE_HIBOUDIGITAL_CONTRACT_APPLICANT) {
                    userId = this.user.userMetaData.userMifirma.id
                }
            })

            let allContracts = await this.followUpContractsService.getContractFilter(this.token, lawyerId, userId, paramDateStart, paramDateLimit, this.timezone)
            if (!allContracts || allContracts.length <= 0 || !allContracts[0].clientContract) throw new Error('Ocurrió un error al cosultar los contratos')
            allContracts = allContracts[0].clientContract.map((contract) => {
                contract.typeContract = contract.questionnaire.name
                return contract
            })

            let contracts = []
            if (companyId === '1' && questionnaireId === NIL_UUID) {
                contracts = allContracts
            } else if (companyId === '1') {
                contracts = allContracts.filter((contract) => contract.questionnaire.id === questionnaireId)
            } else if (questionnaireId === NIL_UUID) {
                contracts = allContracts.filter((contract) => contract.questionnaire.companyId === companyId)
            } else {
                contracts = allContracts.filter((contract) =>
                    contract.questionnaire.companyId === companyId &&
                    contract.questionnaire.id === questionnaireId
                )
            }

            contracts = contracts.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

            this.setState({
                contracts
            })

            this.toggleLoadingView(false)
        } catch (error) {
            this.toggleLoadingView(false)
            this.props.toggleErrorRequesting(messageError, 4000, false, "/")
            setTimeout(() => {
                setShowPoup(true)
            }, 4000)
        }
    }

    setDataSearch = async (data) => {
        let { companyId, questionnaireId, startdate, endDate } = data
        let dataSearch = {
            companyId,
            questionnaireId,
            startdate,
            endDate,
            createdDate: new Date()
        }


        await this.cacheStorageService.saveToCache('/searchContract', dataSearch)
    }

    render() {
        return (
            <CreateDocumentsPrincipalView
                {...this.props}
                {...this.state}

                handleSearchContracts={this.handleSearchContracts}
                setDataSearch={this.setDataSearch}
            />
        )
    }
}

export { CreateDocumentsPrincipalAction as default }